import {Injectable} from '@angular/core';
import {HttpHelper} from '../../http-helper';
import {Observable} from 'rxjs';
import {TaskTypeResponse} from "../models/task-type.model";

@Injectable({providedIn: 'root'})
export class TaskTypeService {

  constructor(private httpHelper: HttpHelper) {
  }

  getTaskTypes(): Observable<TaskTypeResponse> {
    return this.httpHelper.getRequest("/jira/tasktypes")
  }
}
